import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)

router.beforeEach((to, from, next) => {
  if(to.meta.loginRequired){
    if(store.getters['user/getToken'] && store.getters['user/getUserInfo']){
      next();
    }else{
      store.commit('setCred', 'login')
      // next('/network/login');
      /*if(confirm('请先登录再访问。去登录？')){
        next('/login');
      }else{
        window.history.back(-1);
        return;
      }*/
    }
  }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js